import { render, staticRenderFns } from "./TopicsPanelModal.vue?vue&type=template&id=a6a83a30&scoped=true"
import script from "./TopicsPanelModal.vue?vue&type=script&lang=js"
export * from "./TopicsPanelModal.vue?vue&type=script&lang=js"
import style0 from "./TopicsPanelModal.vue?vue&type=style&index=0&id=a6a83a30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6a83a30",
  null
  
)

export default component.exports